import { api } from 'api';
import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
const isElectron = api.getSystemApi().isElectron();
const inEdm = process.env.BUILD_ISEDM;
export function useTabs(tabs, sidebarRef, accountCount) {
    const [sidebarHeight, setSidebarHeight] = useState(660);
    const [showCount, setShowCount] = useState(6);
    const [tabToDisplay, setTabToDisplay] = useState([]);
    const [tabInMore, setTabInMore] = useState([]);
    const ItemHeight = inEdm ? 58 : 70;
    const debounceOb = debounce(entries => {
        const { contentRect } = entries[0];
        if (contentRect.height > 180) {
            setSidebarHeight(contentRect.height);
        }
    }, 500);
    useEffect(() => {
        const ob = new ResizeObserver(debounceOb);
        sidebarRef.current && ob.observe(sidebarRef.current);
        return () => {
            ob.disconnect();
        };
    }, [sidebarRef.current]);
    useEffect(() => {
        let paddingBottom = 0;
        if (inEdm) {
            paddingBottom = accountCount === 0 ? 56 : 42;
        }
        else if (isElectron) {
            paddingBottom = accountCount >= 2 ? 108 : accountCount * 64 + 30;
        }
        const h = sidebarHeight - paddingBottom;
        const count = Math.floor(h / ItemHeight) - (inEdm ? 0 : 1);
        setShowCount(count);
    }, [accountCount, sidebarHeight]);
    useEffect(() => {
        let count = 0;
        const idx = tabs.findIndex(item => {
            if (!item.hidden) {
                count += 1;
            }
            return count === showCount;
        });
        let tabToShow;
        let rest = [];
        if (idx > -1 && idx < tabs.length - 1) {
            tabToShow = tabs.slice(0, idx + (inEdm ? 0 : 1));
            rest = tabs.slice(idx + (inEdm ? 0 : 1)).filter(tab => !tab.hidden);
            setTabToDisplay(tabToShow);
            setTabInMore(rest);
        }
        else if (showCount > 0) {
            setTabToDisplay(tabs);
            setTabInMore(prev => {
                if (prev.length === 0) {
                    return prev;
                }
                return [];
            });
        }
    }, [showCount, tabs]);
    return {
        tabInMore,
        tabToDisplay,
    };
}
